<template>
  <div class="page">
    <el-tabs v-model="activeTab" class="main-tabs" @tab-change="onTabChange">
      <!-- 物流列表 -->
      <el-tab-pane label="物流列表" name="logistics">
        <div class="toolbar">
      <el-form :inline="true" class="toolbar-form" @submit.prevent>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="startDate"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始日期"
            :clearable="false"
            class="date-short"
            :style="{ width: '180px' }"
          />
        </el-form-item>

        <el-form-item label="结束时间">
          <el-date-picker
            v-model="endDate"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束日期"
            :clearable="false"
            class="date-short"
            :style="{ width: '180px' }"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="status" size="default">
            <el-radio-button :label="''">全部</el-radio-button>
            <el-radio-button :label="0">跟踪</el-radio-button>
            <el-radio-button :label="1">已签收</el-radio-button>
            <el-radio-button :label="2">疑难</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="来源">
          <el-select v-model="sourceType" style="width: 120px" @change="onQuery">
            <el-option label="全部" :value="''" />
            <el-option label="销售出库" :value="0" />
            <el-option label="其他出库" :value="1" />
          </el-select>
        </el-form-item>

        <el-form-item label="组织">
          <el-select
            v-model="orgs"
            multiple
            collapse-tags
            collapse-tags-tooltip
            clearable
            filterable
            placeholder="全部组织"
            style="width: 200px"
          >
            <el-option v-for="o in orgOptions" :key="o.value" :label="o.label" :value="o.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="搜索">
          <el-input
            v-model="search"
            placeholder="请输入关键字"
            clearable
            @keyup.enter="onQuery"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="loading" @click="onQuery">查询</el-button>
          <el-button type="success" :loading="pulling" @click="onPull">拉取</el-button>
          <el-button type="warning" :loading="processing" @click="onProcess">处理</el-button>
          <el-button type="info" @click="onLogout">退出登录</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-card class="table-card" shadow="never">
      <el-table :data="rows" v-loading="loading" border stripe>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="billNo" label="单号" min-width="140" />
        <el-table-column prop="logComCode" label="物流公司" min-width="120" />
        <el-table-column prop="sourceTypeName" label="来源" width="90" />
        <el-table-column prop="orgName" label="组织" min-width="120" show-overflow-tooltip />
        <el-table-column prop="carryBillNo" label="运单号" min-width="140" />
        <el-table-column prop="phone" label="电话" width="120" />
        <el-table-column label="状态" width="100">
          <template #default="scope">
            <el-tag :type="stateType(scope.row.state)">
              {{ scope.row.statusName || statusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上传" width="100">
          <template #default="scope">
            <el-tooltip
              v-if="scope.row.sourceType === 0 && scope.row.uploadStatus === 2"
              :content="scope.row.uploadRemark"
              placement="top"
            >
              <el-tag type="danger">上传失败</el-tag>
            </el-tooltip>
            <el-tag v-else-if="scope.row.sourceType === 0" :type="uploadStatusType(scope.row.uploadStatus)">
              {{ uploadStatusLabel(scope.row.uploadStatus) }}
            </el-tag>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column prop="createTime" label="拉取时间" width="170" />
        <el-table-column prop="updateTime" label="更新时间" width="170" />
        <el-table-column label="操作" width="100" fixed="right">
          <template #default="scope">
            <el-button
              v-if="scope.row.sourceType === 0"
              type="primary"
              link
              :loading="retryingId === scope.row.id"
              :disabled="retryingId === scope.row.id"
              @click="onRetry(scope.row)"
            >
              重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000, 2000]"
          @current-change="onPageChange"
          @size-change="onPageSizeChange"
        />
      </div>
    </el-card>
      </el-tab-pane>

      <!-- 用户管理（仅管理员可见） -->
      <el-tab-pane v-if="isAdmin" label="用户管理" name="users">
        <div class="toolbar">
          <el-form :inline="true" class="toolbar-form" @submit.prevent>
            <el-form-item label="搜索">
              <el-input
                v-model="userSearch"
                placeholder="用户名/显示名称"
                clearable
                @keyup.enter="onUserQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="userLoading" @click="onUserQuery">查询</el-button>
              <el-button type="success" @click="openAddDialog">添加用户</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-card class="table-card" shadow="never">
          <el-table :data="userRows" v-loading="userLoading" border stripe>
            <el-table-column prop="userName" label="用户名" min-width="140" />
            <el-table-column prop="displayName" label="显示名称" min-width="120" />
            <el-table-column label="管理员" width="90">
              <template #default="scope">
                <el-tag v-if="scope.row.isAdmin" type="warning">管理员</el-tag>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
            <el-table-column prop="createTime" label="登记时间" width="170" />
            <el-table-column label="允许登录" width="100">
              <template #default="scope">
                <el-switch
                  :model-value="scope.row.canLogin"
                  @change="(val) => onToggleCanLogin(scope.row, val)"
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" fixed="right">
              <template #default="scope">
                <el-button type="danger" link @click="onDeleteUser(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pager">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="userTotal"
              :page-size="userPageSize"
              :current-page="userPage"
              :page-sizes="[10, 20, 50, 100]"
              @current-change="onUserPageChange"
              @size-change="onUserPageSizeChange"
            />
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <!-- 添加用户弹窗 -->
    <el-dialog v-model="addDialogVisible" title="添加用户" width="420px">
      <el-form label-width="80px">
        <el-form-item label="用户名" required>
          <el-input v-model="addForm.userName" placeholder="ERP登录名（自动转为小写）" maxlength="64" />
        </el-form-item>
        <el-form-item label="显示名称">
          <el-input v-model="addForm.displayName" maxlength="64" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" maxlength="256" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="adding" @click="onAddUser">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import { apiUrl } from '../api/config'

function pad2(n) {
  return String(n).padStart(2, '0')
}

function formatDate(date) {
  if (!date) return ''
  const d = new Date(date)
  const y = d.getFullYear()
  const m = pad2(d.getMonth() + 1)
  const day = pad2(d.getDate())
  const hh = pad2(d.getHours())
  const mm = pad2(d.getMinutes())
  const ss = pad2(d.getSeconds())
  return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
}

function getMonthStart(date = new Date()) {
  const d = new Date(date)
  return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0)
}

function getMonthEnd(date = new Date()) {
  const d = new Date(date)
  return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59)
}

function getAuthHeaders() {
  const token = localStorage.getItem('token')
  const headers = {
    Accept: 'application/json'
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

function handleAuthError(res) {
  if (res.status === 401) {
    localStorage.removeItem('token')
    localStorage.removeItem('userName')
    localStorage.removeItem('expireAt')
    localStorage.removeItem('isAdmin')
    window.location.reload()
    throw new Error('登录已过期，请重新登录')
  }
}

// 从错误响应中提取后端返回的 message（业务异常时为 BaseResponse JSON）
async function extractError(res) {
  const text = await res.text().catch(() => '')
  try {
    const json = JSON.parse(text)
    return json?.message || `HTTP ${res.status}`
  } catch {
    return `HTTP ${res.status} ${text}`
  }
}

async function requestJson(urlOrPath) {
  const url = /^https?:\/\//i.test(urlOrPath) ? urlOrPath : apiUrl(urlOrPath)
  const res = await fetch(url, {
    method: 'GET',
    headers: getAuthHeaders()
  })

  handleAuthError(res)

  if (!res.ok) {
    throw new Error(await extractError(res))
  }

  return await res.json()
}

async function postJson(urlOrPath, payload) {
  const url = /^https?:\/\//i.test(urlOrPath) ? urlOrPath : apiUrl(urlOrPath)
  const headers = getAuthHeaders()
  headers['Content-Type'] = 'application/json'

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload ?? {})
  })

  handleAuthError(res)

  const text = await res.text().catch(() => '')
  if (!res.ok) {
    throw new Error(await extractError(res))
  }

  try {
    return text ? JSON.parse(text) : null
  } catch {
    throw new Error(text || '响应不是合法 JSON')
  }
}

async function postNumber(urlOrPath, value) {
  const url = /^https?:\/\//i.test(urlOrPath) ? urlOrPath : apiUrl(urlOrPath)
  const headers = getAuthHeaders()
  headers['Content-Type'] = 'application/json'

  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(Number(value))
  })

  handleAuthError(res)

  const text = await res.text().catch(() => '')
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${text}`)
  }

  try {
    return text ? JSON.parse(text) : null
  } catch {
    throw new Error(text || '响应不是合法 JSON')
  }
}

export default {
  name: 'LogisticsList',
  emits: ['logout'],
  setup(_, { emit }) {
    const loading = ref(false)
    const pulling = ref(false)
    const processing = ref(false)
    const retryingId = ref(null)

    // 当前用户是否管理员（决定是否显示用户管理标签页）
    const isAdmin = ref(localStorage.getItem('isAdmin') === 'true')
    const activeTab = ref('logistics')

    // 默认区间：本月1号到本月底
    const startDate = ref(getMonthStart())
    const endDate = ref(getMonthEnd())

    // 状态筛选：''=全部，0=跟踪，1=成功，2=失败
    const status = ref('')
    const sourceType = ref('')
    const search = ref('')

    // 组织多选筛选：orgs=已选组织名称，orgOptions=下拉选项（来自 K3Cloud ORG_Organizations）
    const orgs = ref([])
    const orgOptions = ref([])

    const page = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const rows = ref([])

    const statusLabel = (s) => {
      if (s === 0) return '跟踪'
      if (s === 1) return '已签收'
      if (s === 2) return '疑难'
      return String(s ?? '')
    }

    // 与移动端 STATE_BADGE_CLASS 一致：按后端统一展示状态映射标签样式
    const STATE_TAG_TYPE = {
      signed: 'success',
      picked: 'success',
      transit: 'info',
      error: 'danger',
      pending: 'warning'
    }
    const stateType = (state) => STATE_TAG_TYPE[state] || 'info'

    const uploadStatusLabel = (s) => {
      if (s === 1) return '已上传'
      if (s === 2) return '上传失败'
      return '待上传'
    }

    const uploadStatusType = (s) => {
      if (s === 1) return 'success'
      if (s === 2) return 'danger'
      return 'warning'
    }

    const queryString = computed(() => {
      const params = new URLSearchParams({
        startTime: formatDate(startDate.value),
        endTime: formatDate(endDate.value),
        page: String(page.value),
        pageSize: String(pageSize.value)
      })

      if (status.value !== '' && status.value !== null && status.value !== undefined) {
        params.set('status', String(status.value))
      }

      if (sourceType.value !== '' && sourceType.value !== null && sourceType.value !== undefined) {
        params.set('sourceType', String(sourceType.value))
      }

      if (search.value !== '' && search.value !== null && search.value !== undefined) {
        params.set('search', String(search.value))
      }

      if (orgs.value && orgs.value.length > 0) {
        orgs.value.forEach(o => params.append('orgNames', o))
      }

      return params.toString()
    })

    const fetchOrgOptions = async () => {
      try {
        const json = await requestJson('/Api/OutStock/GetOrganizations')
        if (json?.code !== 0) {
          throw new Error(json?.message || '获取组织列表失败')
        }
        orgOptions.value = (json?.data ?? []).map(o => ({ label: o.fName, value: o.fName }))
      } catch (e) {
        ElMessage.error(e?.message || '获取组织列表失败')
      }
    }

    const fetchList = async () => {
      loading.value = true
      try {
        const url = `/Api/OutStock/GetLogisticsrPage?${queryString.value}`
        const json = await requestJson(url)

        if (json?.code !== 0) {
          throw new Error(json?.message || '接口返回失败')
        }

        total.value = json?.data?.total ?? 0
        rows.value = json?.data?.list ?? []
      } catch (e) {
        ElMessage.error(e?.message || '查询失败')
      } finally {
        loading.value = false
      }
    }

    const onQuery = async () => {
      page.value = 1
      await fetchList()
    }

    const onPull = async () => {
      if (pulling.value) return
      pulling.value = true
      try {
        const startTime = formatDate(startDate.value)
        const endTime = formatDate(endDate.value)

        if (!startTime || !endTime) {
          ElMessage.error('请选择开始时间和结束时间')
          return
        }

        const json = await postJson('/Api/OutStock/PullOutStockLogistics', {
          startTime,
          endTime
        })

        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '拉取失败')
        }

        ElMessage.success(json?.data || json?.message || '操作成功')
        await fetchList()
      } catch (e) {
        ElMessage.error(e?.message || '拉取失败')
      } finally {
        pulling.value = false
      }
    }

    const onProcess = async () => {
      if (processing.value) return
      processing.value = true
      try {
        const startTime = formatDate(startDate.value)
        const endTime = formatDate(endDate.value)

        if (!startTime || !endTime) {
          ElMessage.error('请选择开始时间和结束时间')
          return
        }

        const json = await postJson('/Api/OutStock/BatchUploadLogistics', {
          startTime,
          endTime
        })

        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '处理失败')
        }

        ElMessage.success(json?.data || json?.message || '操作成功')
        await fetchList()
      } catch (e) {
        ElMessage.error(e?.message || '处理失败')
      } finally {
        processing.value = false
      }
    }

    const onRetry = async (row) => {
      try {
        const id = row?.id
        if (id === null || id === undefined || id === '') {
          ElMessage.error('缺少 ID，无法重试')
          return
        }

        if (Number(row?.status) === 1) {
          try {
            await ElMessageBox.confirm(
              '该条物流当前状态为“成功”，确认要重试吗？',
              '二次确认',
              {
                confirmButtonText: '确认重试',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
          } catch {
            return
          }
        }

        if (retryingId.value !== null) return
        retryingId.value = id

        const json = await postNumber('/Api/OutStock/UploadLogistics', id)
        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '重试失败')
        }

        ElMessage.success(json?.data || json?.message || '操作成功')
        await fetchList()
      } catch (e) {
        ElMessage.error(e?.message || '重试失败')
      } finally {
        retryingId.value = null
      }
    }

    const onPageChange = async (p) => {
      page.value = p
      await fetchList()
    }

    const onPageSizeChange = async (s) => {
      pageSize.value = s
      page.value = 1
      await fetchList()
    }

    const onLogout = () => {
      emit('logout')
    }

    // ===== 用户管理 =====
    const userLoading = ref(false)
    const userSearch = ref('')
    const userPage = ref(1)
    const userPageSize = ref(10)
    const userTotal = ref(0)
    const userRows = ref([])
    const adding = ref(false)
    const addDialogVisible = ref(false)
    const addForm = ref({ userName: '', displayName: '', remark: '' })

    const fetchUsers = async () => {
      if (!isAdmin.value) return
      userLoading.value = true
      try {
        const params = new URLSearchParams({
          page: String(userPage.value),
          pageSize: String(userPageSize.value)
        })
        if (userSearch.value) {
          params.set('search', userSearch.value.trim())
        }
        const json = await requestJson(`/Api/User/PageList?${params.toString()}`)
        if (json?.code !== 0) {
          throw new Error(json?.message || '查询失败')
        }
        userTotal.value = json?.data?.total ?? 0
        userRows.value = json?.data?.list ?? []
      } catch (e) {
        ElMessage.error(e?.message || '查询用户失败')
      } finally {
        userLoading.value = false
      }
    }

    const onUserQuery = async () => {
      userPage.value = 1
      await fetchUsers()
    }

    const onUserPageChange = async (p) => {
      userPage.value = p
      await fetchUsers()
    }

    const onUserPageSizeChange = async (s) => {
      userPageSize.value = s
      userPage.value = 1
      await fetchUsers()
    }

    // 切换到用户管理标签时加载一次
    const onTabChange = (name) => {
      if (name === 'users' && userRows.value.length === 0) {
        fetchUsers()
      }
    }

    const openAddDialog = () => {
      addForm.value = { userName: '', displayName: '', remark: '' }
      addDialogVisible.value = true
    }

    const onAddUser = async () => {
      if (!addForm.value.userName || !addForm.value.userName.trim()) {
        ElMessage.warning('请输入用户名')
        return
      }
      if (adding.value) return
      adding.value = true
      try {
        const json = await postJson('/Api/User/Add', {
          userName: addForm.value.userName,
          displayName: addForm.value.displayName,
          remark: addForm.value.remark
        })
        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '添加失败')
        }
        ElMessage.success('添加成功，默认禁止登录，请打开“允许登录”开关')
        addDialogVisible.value = false
        await fetchUsers()
      } catch (e) {
        ElMessage.error(e?.message || '添加失败')
      } finally {
        adding.value = false
      }
    }

    const onToggleCanLogin = async (row, val) => {
      try {
        const json = await postJson('/Api/User/UpdateCanLogin', {
          id: row.id,
          canLogin: val
        })
        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '更新失败')
        }
        row.canLogin = val
        ElMessage.success(val ? `已允许 ${row.userName} 登录` : `已禁止 ${row.userName} 登录`)
      } catch (e) {
        ElMessage.error(e?.message || '更新失败')
      }
    }

    const onDeleteUser = async (row) => {
      try {
        await ElMessageBox.confirm(
          `确认删除用户 ${row.userName} 吗？删除后该用户将无法登录。`,
          '删除确认',
          {
            confirmButtonText: '确认删除',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
      } catch {
        return
      }

      try {
        const json = await postJson(`/Api/User/Delete?id=${row.id}`)
        if (Number(json?.code) !== 0) {
          throw new Error(json?.message || '删除失败')
        }
        ElMessage.success('删除成功')
        await fetchUsers()
      } catch (e) {
        ElMessage.error(e?.message || '删除失败')
      }
    }

    onMounted(() => {
      fetchList()
      fetchOrgOptions()
    })

    return {
      loading,
      pulling,
      processing,
      retryingId,
      startDate,
      endDate,
      status,
      sourceType,
      search,
      orgs,
      orgOptions,
      page,
      pageSize,
      total,
      rows,
      statusLabel,
      stateType,
      uploadStatusLabel,
      uploadStatusType,
      isAdmin,
      activeTab,
      onTabChange,
      userLoading,
      userSearch,
      userPage,
      userPageSize,
      userTotal,
      userRows,
      adding,
      addDialogVisible,
      addForm,
      onQuery,
      onPull,
      onProcess,
      onRetry,
      onPageChange,
      onPageSizeChange,
      onLogout,
      onUserQuery,
      onUserPageChange,
      onUserPageSizeChange,
      openAddDialog,
      onAddUser,
      onToggleCanLogin,
      onDeleteUser
    }
  }
}
</script>

<style scoped>
.page {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding: 16px;
  background:
    radial-gradient(780px 420px at 100% 0%, rgba(159, 201, 255, 0.24) 0%, rgba(159, 201, 255, 0) 68%),
    radial-gradient(640px 360px at 0% 100%, rgba(164, 231, 197, 0.2) 0%, rgba(164, 231, 197, 0) 70%),
    linear-gradient(180deg, #f7fbff 0%, #f2f7fb 100%);
}

.toolbar {
  position: relative;
  z-index: 1;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(244, 250, 255, 0.7);
  border: 1px solid rgba(208, 224, 241, 0.72);
}

.main-tabs {
  position: relative;
  z-index: 1;
}

.main-tabs :deep(.el-tabs__item) {
  font-size: 15px;
}

.toolbar-form {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}

.date-short {
  width: 120px;
}

.table-card {
  position: relative;
  z-index: 1;
  border-radius: 10px;
  background: rgba(246, 251, 255, 0.78);
  border: 1px solid rgba(203, 221, 240, 0.74);
  backdrop-filter: blur(6px);
  box-shadow: 0 8px 26px rgba(64, 101, 146, 0.09);
}

.table-card :deep(.el-card__body) {
  background: rgba(248, 252, 255, 0.7);
}

.table-card :deep(.el-table) {
  --el-table-bg-color: rgba(250, 253, 255, 0.82);
  --el-bg-color: rgba(250, 253, 255, 0.82);
  --el-table-tr-bg-color: rgba(250, 253, 255, 0.82);
  --el-fill-color-lighter: rgba(241, 247, 253, 0.92);
  --el-table-row-hover-bg-color: rgba(226, 239, 252, 0.65);
}

.table-card :deep(.el-table th.el-table__cell) {
  background: rgba(233, 243, 252, 0.88);
  color: #1f3a55;
}

.table-card :deep(.el-table tr) {
  background: rgba(250, 253, 255, 0.82);
}

.table-card :deep(.el-table__row--striped td.el-table__cell) {
  background: rgba(244, 249, 254, 0.9);
}

.table-card :deep(.el-table__row:hover > td.el-table__cell) {
  background: rgba(226, 239, 252, 0.65) !important;
}

.pager {
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;
}
</style>
